import { CrudService } from "../services/crud.service";
import { message } from "../shared/message";

const initialState = {
  data: {},
  item: {}
};

const resource = "dashboard-widget";

export const dashboardWidget = {
  namespaced: true,
  state: initialState,
  actions: {
    getDashboardWidgetList({ commit, rootState }) {
      CrudService.of(`${resource}`).getList(rootState.common.pagination, rootState.common.searchQuery).then(data => {
        commit("loadDashboardWidgetList", data);
        commit("common/setTotalItems", data.totalElements, { root: true });
      });
    },
    getDashboardWidget({ commit }, id) {
      CrudService.of(`${resource}`).getItem(id).then(item => {
        commit("loadDashboardWidget", item);
      });
    },
    createDashboardWidget(context, dashboardWidget) {
      CrudService.of(`${resource}`).createItem( dashboardWidget).then(() =>
          message.success("Create Dashboard Widget Success!", "/dashboard-widget/list"));
    },
    updateDashboardWidget(context, dashboardWidget) {
      CrudService.of(`${resource}`).updateItem(dashboardWidget).then(() =>
          message.success("Update Dashboard Widget Success!", "/dashboard-widget/list"));
    },
    deleteDashboardWidget({ dispatch }, id) {
      CrudService.of(`${resource}`).deleteItem(id).then(() => {
        dispatch("getDashboardWidgetList");
      });
    }
  },
  mutations: {
    loadDashboardWidgetList(state, data) {
      state.data = data;
    },
    loadDashboardWidget(state, item) {
      state.item = item;
    }
  }
};
